import { cn } from '../utils/cn';

interface CheckboxInputProps {
  label: string;
  name: string;
  checked?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  error?: string;
  disabled?: boolean;
  className?: string;
}

export default function CheckboxInput({ label, name, checked, onChange, error, disabled, className }: CheckboxInputProps) {
  return (
    <div className={cn('space-y-1', className)}>
      <label className={cn('flex items-center gap-2 cursor-pointer', disabled && 'opacity-50 cursor-not-allowed')}>
        <input
          type="checkbox"
          name={name}
          checked={checked}
          onChange={onChange}
          disabled={disabled}
          className="h-4 w-4 rounded border-border text-primary focus:ring-primary accent-primary"
        />
        <span className="text-sm text-content-secondary">{label}</span>
      </label>
      {error && <p className="text-xs text-danger">{error}</p>}
    </div>
  );
}
